module.exports = __webpack_public_path__ + "img/logo.e2bdc170.png";